import { useEffect } from 'react'

import Box from '@totallymoney/ui/components/Box'
import Grid from '@totallymoney/ui/components/Grid'
import Heading from '@totallymoney/ui/components/Heading'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'
import theme from '@totallymoney/ui/theme'

import { CreditCardAlternativeProductsCategory } from '@appTypes/EligibilityApi.interface'

import { LoggerKey } from '@config/logger'

import useLogger from '@hooks/useLogger'
import useSetState from '@hooks/useSetState'

import { getIsProductPortraitImage } from '@utils/getIsProductPortraitImage'

import AlternativeProductsTableHeader from '../../../AlternativeProductsTableRoute/components/AlternativeProductsTable/components/AlternativeProductsTableHeader'
import AlternativeProductsTableItem from '../../../AlternativeProductsTableRoute/components/AlternativeProductsTable/components/AlternativeProductsTableItem'
import getCategoryByAlternativeCategoryId from '../../../AlternativeProductsTableRoute/components/AlternativeProductsTable/utils/getCategoryByAlternativeProductCategoryId'

interface AlternativeProductsTableProps {
    alternativeProductCategories: CreditCardAlternativeProductsCategory[]
}

interface AlternativeProductsTableState {
    selectedCategory: string
}

const AlternativeProductsTable = ({
    alternativeProductCategories,
}: AlternativeProductsTableProps) => {
    const [alternativeProductsState, setAlternativeProductsState] =
        useSetState<AlternativeProductsTableState>({
            selectedCategory: alternativeProductCategories[0].id,
        })
    const { logInfo } = useLogger()

    const onCategoryChange = (category: string) => {
        setAlternativeProductsState({
            selectedCategory: category,
        })
    }

    const activeCategory = getCategoryByAlternativeCategoryId(
        alternativeProductCategories,
        alternativeProductsState.selectedCategory
    )

    const onApplyPress = () => {
        window.location.href = 'https://www.totallymoney.com/myaccount/login'
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            logInfo(LoggerKey.UnscoredAlternativeProductsView, {})
        }
    }, [])

    return (
        <Box backgroundColor="productNeutral60" pb="space60" pt="space50">
            <Grid>
                <Box gridColumn="1/13" pb="space30">
                    <Stack space="space30">
                        <Box>
                            <Heading variant="100">
                                Alternative products
                            </Heading>
                            <Text variant="120">
                                Log in to see what you could be eligible for
                            </Text>
                        </Box>
                    </Stack>
                </Box>
            </Grid>
            <AlternativeProductsTableHeader
                categories={alternativeProductCategories}
                initialCategory={alternativeProductCategories[0].id}
                onCategoryChange={onCategoryChange}
            />
            <Box pb="space50" />
            <Grid>
                <Box gridColumn="1/13" mb="space50">
                    <Box mb="space20">
                        <Heading variant="60">
                            {activeCategory?.displayName}
                        </Heading>
                    </Box>
                    <Text variant="120">{activeCategory?.description}</Text>
                </Box>
            </Grid>
            <Grid style={{ gridGap: theme.space30 }}>
                {activeCategory?.alternativeProducts.map(alternativeProduct => {
                    return (
                        <Box
                            gridColumn="1/13"
                            key={alternativeProduct.productCode}
                        >
                            <AlternativeProductsTableItem
                                item={alternativeProduct}
                                applyHref={''}
                                isPortraitImage={getIsProductPortraitImage(
                                    alternativeProduct.productCode
                                )}
                                onApplyPress={() => {
                                    onApplyPress()
                                }}
                            />
                        </Box>
                    )
                })}
            </Grid>
        </Box>
    )
}

export default AlternativeProductsTable
